// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"52cea8b7","122":"0083a187","823":"f5a13af8","885":"d46c1261"}[chunkId] + ".css";
};